import React from 'react'

import Footer from 'components/Footer'

import { Wrapper, Main, FooterWrapper, Content } from './IndexLayout.styles'

import { IndexLayoutHeader, IndexLayoutHeaderProps } from './IndexLayoutHeader'
import Sidebar, { Variant } from './Sidebar'

export interface IndexLayoutProps extends IndexLayoutHeaderProps {
  className?: string
  variant?: Variant
  isCreatingWorkspace?: boolean
  fullWidth?: boolean
  maxContainerWidth?: string
}

const IndexLayout: React.FC<IndexLayoutProps> = ({
  className,
  children,
  headerLink,
  blockLogoLink,
  variant,
  isCreatingWorkspace,
  fullWidth,
  maxContainerWidth,
}) => {
  return (
    <Wrapper className={className}>
      <IndexLayoutHeader
        headerLink={headerLink}
        blockLogoLink={blockLogoLink}
      />
      {variant && <Sidebar variant={variant} />}
      <Content>
        <Main
          isCreatingWorkspace={isCreatingWorkspace}
          fullWidth={fullWidth}
          maxContainerWidth={maxContainerWidth}
        >
          {children}
        </Main>
        <FooterWrapper>
          <Footer />
        </FooterWrapper>
      </Content>
    </Wrapper>
  )
}

export default IndexLayout
